// extracted by mini-css-extract-plugin
module.exports = {"food":"Home-module--food--1x3N7"};